var map = {
	"./MenuBus": 5616,
	"./MenuBus.js": 5616,
	"./MenuScreen": 7564,
	"./MenuScreen.js": 7564,
	"./MenuTexts": 4766,
	"./MenuTexts.js": 4766
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9452;
module.exports = webpackAsyncContext;